<div class="row  align-baseline" *ngIf="config.options.hideAll!=='hide' && config.options.hideAll!=='notDisplay'" [formGroup]="group"  [class.form-group]="!group.disabled">

  <!-- label if isEdit    [class.col-sm-2]="config.presentation === 'filter'" -->
  <label for="{{config.label}}" [class]="config.options.labelSize ? 'col-sm-6' : 'col-sm-3' "
        [style]="!config.options.labelSize ?  'white-space: nowrap': 'white-space: nowrap'" class="control-label" style="margin-right: 8px;">
    <ng-container *ngIf="config.options.labelPosition === 'left'">{{config.label | translate:locale.language}}</ng-container>
  </label>


  <div class="parent-container"
      [class.col-sm-7]="config.options.inputOptions && !config.options.labelSize"
      [class.col-sm-9]="!config.options.inputOptions && !config.options.labelSize"
      [class.col-sm-4]="config.options.labelSize">
    <!--  normal form  -->

    <div style="width: 78px;" [className]="config.options.inputOptions ? 'bot' : null"
         [style]="config.options.labelSize ?  'top: -15px': ''" >
      <label for="{{config.label}}" class="control-label container pull" [class.noneClick]="checkValidity()">
        <input formControlName="{{config.controlName[0]}}"
               class="form-check-input"
               type="checkbox"
               value="" id="{{config.label}}">
        <span class="checkmark"></span>
      </label>

      <label *ngIf="config.options.labelPosition === 'right'" for="{{config.label}}" class="row col-sm-3 control-label" style="white-space: nowrap;margin-right: 8px;">
        {{config.label | translate:locale.language}}
      </label>
    </div>
  </div>
  <storever-input-options  style="position: relative ; right: -1px" class="col-sm-1" *ngIf="config.options.inputOptions" [config]="config"></storever-input-options>
  <div *ngIf="config.options.description" class="align-position" style="cursor: pointer" (click)="displayDescription(true)">
    <i class="fal fa-info"></i>
  </div>
</div>

<alert [type]="'info'" *ngIf="isDescription" [dismissible]="isDescription" (onClosed)="displayDescription(false)" class="alertSize">
  <h4 class="alert-heading">Invoice New Player</h4>
  <p>
    Checking this checkbox will include the contract in the monthly invoicing process for new players. Here's how it works:
  </p>
  <ul>
    <li>The new player will be invoiced for the period between their deployment and the end of the current invoicing period.</li>
    <li>The invoicing will include any previous months that have not yet been invoiced.</li>
    <li>Future invoices will then be generated according to the regular billing cycle.</li>
  </ul>
  <hr>
  <h5>Example Timeline</h5>
  <p>
    Company "My Little Store" has an annual invoicing cycle starting on January 1st. If a new player is deployed on April 5th, the monthly invoicing will handle the following:
  </p>
  <ul>
    <li>The player will be invoiced for the 26 days in April (from April 5th to April 30th) on May 1st.</li>
    <li>Additionally, the player will be invoiced for the remaining 8 months of the annual cycle, up until the next January 1st.</li>
  </ul>
  <p>
    This ensures that all new players are billed fairly for their service period, even if they are added partway through the billing cycle.
  </p>
</alert>

<div *ngIf="false">
  <pre>control:{{config.controlName[0]}}</pre>
  <pre>checkbox form:{{group.get(config.controlName[0]).value}}</pre>
  <pre>presentation:{{this.config.presentation}}</pre>
  <pre>dirty:{{this.group.dirty}}</pre>
  <pre>valid:{{this.group.valid}}</pre>
</div>





